import { render, staticRenderFns } from "./ValidateBankComponent.vue?vue&type=template&id=fc5ce24e"
import script from "./ValidateBankComponent.vue?vue&type=script&lang=js"
export * from "./ValidateBankComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports